export default __webpack_public_path__ + "static/media/12109.0a8c3868.jpg";